<template>
    <div>
        <v-list :rounded="$vuetify.breakpoint.mdAndUp" class="pa-md-0 py-0 px-2" :style="{'border-radius': $vuetify.breakpoint.mdAndUp ? '22pt !important' : null}">
            <!-- <v-slide-x-transition> -->
            <v-subheader v-if="!loading && (future_events + current_events).length == 0"><i>No events</i></v-subheader>
            <!-- </v-slide-x-transition> -->
            <v-slide-x-transition>
            <v-subheader v-if="current_events && current_events.length > 0">Current</v-subheader>
            </v-slide-x-transition>
            <v-slide-x-transition group>
                <template v-for="(event, index) in current_events" two>
                        <v-list-item class="my-0" :key="event.id">
                            <v-list-item-avatar>
                                <v-icon class="primary white--text" v-text="event.type.icon"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <!-- <v-list-item-title>{{ event.type.name[0].toUpperCase() + event.type.name.slice(1) }}</v-list-item-title> -->
                                <v-list-item-title>{{ event.name }}</v-list-item-title>
                                <v-list-item-subtitle><i>{{ Math.abs(Math.floor( (Date.parse(event.end_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d left</i>&nbsp;&bull; <span class="text--primary">{{ event.trainees.map((who) => nameify(who)).join(', ') }}</span></v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="dialog_event = event, event_dialog = true"><v-icon>more_vert</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    <v-divider :key="'d' + index" :inset="$vuetify.breakpoint.mdAndUp" v-if="index < events.filter((e) => e.show).length - 1 && event.show"></v-divider>
                </template>
            </v-slide-x-transition>
            <v-slide-x-transition>
            <v-subheader v-if="future_events && future_events.length > 0">Upcoming</v-subheader>
            </v-slide-x-transition>
            <v-slide-x-transition group>
                <template v-for="(event, index) in future_events" two>
                        <v-list-item class="my-0" :key="event.id">
                            <v-list-item-avatar>
                                <v-icon class="primary white--text" v-text="event.type.icon"/>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <!-- <v-list-item-title>{{ event.type.name[0].toUpperCase() + event.type.name.slice(1) }}</v-list-item-title> -->
                                <v-list-item-title>{{ event.name }}</v-list-item-title>
                                <v-list-item-subtitle><i>in {{ Math.abs(Math.floor( (Date.parse(event.start_date) - Date.now())  / (1e3 * 60 * 60 * 24) )) }}d</i>&nbsp;&bull; <span class="text--primary">{{ event.trainees.map((who) => nameify(who)).join(', ') }}</span></v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click="dialog_event = event, event_dialog = true"><v-icon>more_vert</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    <v-divider :key="'d' + index" :inset="$vuetify.breakpoint.mdAndUp" v-if="index < events.filter((e) => e.show).length - 1 && event.show"></v-divider>
                </template>
            </v-slide-x-transition>
        </v-list>
        <v-snackbar app v-model="snackbar">
            <v-icon left>error</v-icon>
            {{ snackbar_msg }}
        </v-snackbar>
        <div v-if="loading" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100vh">
            <v-progress-circular indeterminate/>
        </div>
        <v-btn
          fab
          @click="dialog_event = null, event_dialog = true"
          fixed
          bottom
          right
          :small="!$vuetify.breakpoint.mdAndUp"
          color="success"
          :style="{'margin-bottom': true || $vuetify.breakpoint.mobile ? '56px' : null}">
            <v-icon v-text="'add'"/>
        </v-btn>
        <v-dialog v-model="event_dialog" max-width="500" :fullscreen="$vuetify.breakpoint.xs" persistent>
            <event-dialog :event="dialog_event" @close="event_dialog = false" @modified="event_dialog = false; get_lessons()"/>
        </v-dialog>
    </div>
</template>

<script>

import EventDialog from './EventDialog.vue'

export default {
    name: 'EventsView',

    components: {
        EventDialog
    },

    data: () => ({

        snackbar: false,
        snackbar_msg: '',
        loading: true,
        event_dialog: false,
        dialog_event: null,

    }),
    computed: {
        students () {
            return this.$store.getters['trainer/students'].slice().sort((a, b) => a.last_name > b.last_name)
        },
        events () {
            return this.$store.getters['trainer/events']
        },
        current_events () {
            return this.$store.getters['trainer/events'].filter(e => (Date.parse(e.start_date) - Date.now() <= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        },
        future_events () {
            return this.$store.getters['trainer/events'].filter(e => (Date.parse(e.start_date) - Date.now() >= 0.) && (Date.parse(e.end_date) - Date.now() >= 0.))
        }
    },
    methods: {
        async get_lessons () {
            try {
                await this.$store.dispatch('trainer/get_lessons');
            } catch (e) {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
            this.loading = false;
        },
        async get_events () {
            try {
                await this.$store.dispatch('trainer/get_events');
            } catch (e) {
                this.snackbar_msg = 'Error fetching data';
                this.snackbar = true;
            }
            this.loading = false;
        },
        nameify(student) {
            if (this.$vuetify.breakpoint.xs) {
                return student.first_name[0] + student.last_name[0]
            } else if (this.$vuetify.breakpoint.width < 1500) {
                return student.first_name.split(' ')[0] + ' ' + student.last_name[0] + '.'
            }
            return student.first_name + ' ' + student.last_name
        }
    },
    async created () {
        if (this.$store.getters['trainer/students'].length == 0) {
            await this.get_lessons();
        }
        await this.get_events();

        document.addEventListener("contextmenu", function (e) {
            e.preventDefault()
        }, false)
    }
};

</script>
